import { FastlyImage } from '@components/common/image'
import { COURSE_FEATURES } from '@components/locale-pages/home/courses'
import { Trans } from '@lingui/macro'
import { Check } from 'react-feather'

type Props = {
  title?: JSX.Element
  courseTitle: string
  description?: JSX.Element
}

const CourseFeatures = ({ title, courseTitle, description }: Props) => {
  const features = COURSE_FEATURES[courseTitle]

  return (
    <div className="flex flex-col text-grey container mx-auto my-10 lg:px-3 py-5">
      <h2 className="text-2xl md:text-2xl font-600 mb-4 leading-tight">
        {title}
      </h2>
      {description && <div className="mb-4">{description}</div>}
      <div className="flex flex-wrap gap-4 mt-4">
        <div className="relative shadow-md rounded-md w-full xl:w-80 p-8">
          <span className="absolute top-0 left-0 z-index-0">
            <FastlyImage
              src="/images/courses/outcome.svg"
              alt="Course Outcomes"
              width={108}
              height={115}
            />{' '}
          </span>
          <h3 className="text-lg font-700 pl-8 pb-4 z-10 relative">
            <Trans>What you will learn</Trans>
          </h3>

          <div className="space-y-1 z-10 relative">
            {features.outcomes.map((outcome, index) => (
              <div key={index} className="flex items-start">
                <span
                  className="rounded-full bg-green-50 bg-opacity-50"
                  style={{ padding: '2px', marginTop: '5px' }}
                >
                  <Check
                    height={10}
                    width={10}
                    strokeWidth={3}
                    className="text-green-200"
                  />
                </span>
                <p className="ml-2 text-left">{outcome}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="relative shadow-md rounded-md w-full xl:w-1/2 p-8 flex flex-col">
          <span className="absolute top-0 left-0 z-index-0">
            <FastlyImage
              src="/images/courses/skills-bg.svg"
              alt="Course Features"
              width={108}
              height={115}
            />
          </span>
          <h3 className="text-lg font-700 pl-8 pb-4 z-10 relative">
            <Trans>Skills you will gain</Trans>
          </h3>

          <div className="z-10 relative grid grid-cols-2 gap-3 text-center my-auto">
            {features.skills.map((skill, index) => (
              <div
                key={index}
                className="flex flex-col items-center justify-start gap-2"
              >
                <FastlyImage
                  src={`${skill.imagePath}.png`}
                  alt={skill.skillName}
                  width={42}
                  height={42}
                  className="object-contain"
                />
                <p className="ml-2 text-xs">{skill.skillName}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CourseFeatures
